import { d as DocContext, j as jsxRuntimeExports, M as MathJax } from "./doenetml-CDvV96YD.js";
import React__default, { useContext } from "react";
import { u as useDoenetRenderer } from "./useDoenetRenderer-YzDSBjpZ.js";
import { A as AnswerResponseButton } from "./AnswerResponseButton-jJqDEQ-1.js";
import { c as calculateValidationState, a as createCheckWorkComponent } from "./checkWork-ELAyU3CF.js";
const answer = React__default.memo(function Answer(props) {
  let {
    componentIdx,
    id,
    SVs,
    docId,
    activityId,
    actions,
    children,
    flags,
    callAction
  } = useDoenetRenderer(props);
  const { showAnswerResponseButton, answerResponseCounts } = useContext(DocContext) || {};
  if (SVs.hidden) {
    return null;
  }
  const submitAnswer = () => callAction({
    action: actions.submitAnswer
  });
  let label = SVs.label;
  if (SVs.labelHasLatex) {
    label = /* @__PURE__ */ jsxRuntimeExports.jsx(MathJax, { hideUntilTypeset: "first", inline: true, dynamic: true, children: label });
  }
  let inputChildrenToRender = null;
  if (SVs.inputChildren.length > 0) {
    let inputChildNames = SVs.inputChildren.map((x) => x.componentIdx);
    inputChildrenToRender = children.filter(
      //child might be null or a string
      (child) => child && typeof child !== "string" && inputChildNames.includes(
        // @ts-ignore
        child.props.componentInstructions.componentIdx
      )
    );
  }
  let answerResponseButton = null;
  if (showAnswerResponseButton) {
    answerResponseButton = /* @__PURE__ */ jsxRuntimeExports.jsx(
      AnswerResponseButton,
      {
        answerId: id,
        answerComponentIdx: componentIdx,
        docId,
        activityId,
        numResponses: answerResponseCounts?.[id],
        flags
      }
    );
  }
  const validationState = calculateValidationState(SVs);
  let checkWorkComponent = createCheckWorkComponent(
    SVs,
    id,
    validationState,
    submitAnswer,
    true
  );
  if (label) {
    checkWorkComponent = /* @__PURE__ */ jsxRuntimeExports.jsxs(
      "label",
      {
        style: {
          display: "inline-flex",
          maxWidth: "100%"
        },
        children: [
          /* @__PURE__ */ jsxRuntimeExports.jsx("span", { style: { marginRight: "4px" }, children: label }),
          checkWorkComponent
        ]
      }
    );
  }
  return /* @__PURE__ */ jsxRuntimeExports.jsxs("span", { id, style: { marginBottom: "4px" }, children: [
    inputChildrenToRender,
    checkWorkComponent,
    answerResponseButton
  ] });
});
export {
  answer as default
};
